<div class="header">
  <div class="title">New Message</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="sendMessageForm">
  <div class="flex flex-auto flex-row mb-2">
    <contact-sharing
      [account]="account"
      [initialTags]="[contact?.email]"
      [label]="'To'"
      [showCCFields]="true"
      (onUpdateTags)="addToEmail($event)"
      (onShowCopyField)="showCopyField($event)"
    ></contact-sharing>
  </div>
  <div class="flex flex-auto flex-row mb-2" *ngIf="copyFields.cc">
    <contact-sharing [account]="account" [label]="'Cc'" (onUpdateTags)="addCCEmail($event)"></contact-sharing>
  </div>
  <div class="flex flex-auto flex-row mb-2" *ngIf="copyFields.bcc">
    <contact-sharing [account]="account" [label]="'Bcc'" (onUpdateTags)="addBCCEmail($event)"></contact-sharing>
  </div>

  <!-- Subject -->
  <mat-form-field class="subject">
    <mat-label>Subject</mat-label>
    <input matInput [formControlName]="'subject'" />
  </mat-form-field>

  <!-- Body -->
  <quill-editor
    [formControlName]="'body'"
    [modules]="quillModules"
    (onEditorCreated)="onEditorCreated($event)"
  ></quill-editor>

  <div class="actions mt-2">
    <div class="formatting">
      <!-- Attach file -->
      <!--<button mat-icon-button>
                <mat-icon [svgIcon]="'attach_file'"></mat-icon>
            </button>-->

      <!-- Insert link -->
      <!--<button mat-icon-button>
                <mat-icon [svgIcon]="'link'"></mat-icon>
            </button>-->

      <!-- Insert emoji -->
      <!--<button mat-icon-button>
                <mat-icon [svgIcon]="'insert_emoticon'"></mat-icon>
            </button>-->

      <!-- Insert image -->
      <!--<button mat-icon-button>
                <mat-icon [svgIcon]="'image'"></mat-icon>
            </button>-->
    </div>

    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Discard</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        type="submit"
        [color]="'primary'"
        [disabled]="sendMessageForm.pristine || sendMessageForm.invalid"
        (click)="sendAndClose()"
      >
        <span>Send</span>
      </button>
    </div>
  </div>
</form>
